import React, { lazy, Suspense, useEffect, useState } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";
import { MdArrowBackIos } from "../utils/Icons";
import { formatDate, calculateAge } from "../utils/DateUtils";
import { capitalizeFirstLetter } from "../utils/OtherUtils";
import { useNavigate } from "react-router-dom";

// Imports
import DashboardWrapper from "../components/DashboardWrapper";
const OrderCard = lazy(() => import("../components/OrderCard"));

const MyOrder = () => {
  const { handleNotification } = useAuthContext();
  const { fetchOrders, allOrders, handleCancelRedcliffeOrder } = useOrderProcessingContext();
  const [isViewOrder, setIsViewOrder] = useState(false);
  const [viewOrder, setViewOrder] = useState({});
  const [cancelInfo, setCancelInfo] = useState(null);
  const navigate = useNavigate();

  const handleViewOrder = (orderToView) => {
    setViewOrder(orderToView);
    setIsViewOrder((prev) => !prev);
  };

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const reversedOrders = [...allOrders].reverse();


  const handleCancelClick = async (orderId) => {
    const response = await handleCancelRedcliffeOrder(orderId);
    setCancelInfo(response.message);
  }
  const formatDateTime = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-IN", options);
  }
  return (
    <DashboardWrapper>
      <div className="w-full h-full">
        {!isViewOrder && (
          <button
            className="flex items-center font-normal text-[4vw]  mb-2 lg:hidden lg:text-[1vw] text-textPrimaryColor"
            onClick={() => navigate(-1)}
          >
            <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
            <span>Back</span>
          </button>
        )}
        {allOrders?.length === 0 && !isViewOrder && (
          <div className="w-full h-full flex justify-center items-center">
            <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
              You haven’t ordered anything yet
            </p>
          </div>
        )}

        {reversedOrders?.length > 0 && !isViewOrder && (
          <div className="w-full h-full flex flex-col justify-between items-center space-y-[3%] lg:space-y-0">
            <div className="w-full h-fit lg:h-[95%] space-y-[4%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
              <Suspense
                fallback={
                  <div className="w-full h-full flex justify-center items-center">
                    <p className="font-normal text-[1vw] text-textSecondaryColor">
                      Loading orders...
                    </p>
                  </div>
                }
              >
                {reversedOrders?.map((order, index) => (
                  <OrderCard key={index} data={order} click={handleViewOrder} />
                ))}
              </Suspense>
            </div>
            <button className="btn-primary">View more</button>
          </div>
        )}

        {isViewOrder && viewOrder && (
          <div className="w-full h-full space-y-[2%]">
            <button
              className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
              onClick={handleViewOrder}
            >
              <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
              <span>Back</span>
            </button>
            <div className="w-full h-fit border border-primaryColor rounded-xl lg:rounded-3xl">
              <div className="w-full h-fit border-b border-accentColor p-[2%] lg:p-[2%]">

                {viewOrder?.orderData?.[0]?.items?.[0]?.product?.brandName === "Redcliffe Labs" ? (
                  <div className="w-full h-fit flex flex-col lg:flex-row justify-between items-start lg:items-center mb-[3%]">
                    {/* <div className="w-full flex flex-col lg:flex-row lg:w-[70%] mb-2 lg:mb-0"> */}
                    <div className="w-full h-fit flex justify-between items-center">
                      <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                        ORDER ID{" "}
                        <span className="text-primaryColor">
                          {viewOrder?.orderId?.slice(6).toUpperCase()}
                        </span>
                      </span>
                      <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor lg:ml-[3%]">
                        {/* Order at : {formatDate(viewOrder?.createdAt)} */}
                        Order at: {formatDateTime(viewOrder?.createdAt)}
                      </span>
                    </div>
                    {/* <span className={`font-bold text-[4vw] lg:text-[1vw] ${viewOrder.status === "Cancelled" ? "text-[#FF3B30]" : "text-[#0047AF]"}`}>
                      ORDER {viewOrder.status.toUpperCase()}
                    </span> */}
                  </div>
                ) : (
                  <div className="w-full h-fit flex justify-between items-center mb-[3%]">
                  {/* // <div className="w-full h-fit flex justify-between items-center"> */}
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                      ORDER ID{" "}
                      <span className="text-primaryColor">
                        {viewOrder?.orderId?.slice(6).toUpperCase()}
                      </span>
                    </span>
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                      {/* Order at : {formatDate(viewOrder?.createdAt)} */}
                      Order at: {formatDateTime(viewOrder?.createdAt)}
                    </span>
                  </div>
                )}
                <div className="w-full h-fit flex justify-between items-center space-x-[2%]">
                  <img
                    src={viewOrder?.orderData?.[0]?.items?.[0]?.product?.brandImg}
                    alt="logo"
                    className="w-[25%] lg:w-[12.5%] h-[25%] lg:h-[12.5%] object-cover rounded-xl lg:rounded-2xl"
                  />
                  <div className="w-[87.5%] h-fit flex justify-between items-start">
                    <div>
                      {viewOrder?.orderData?.map((orderItem, orderIndex) =>
                        orderItem?.items?.map((item, itemIndex) => (
                          <p
                            className="w-[57.5%] font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor"
                            key={`${orderIndex}-${itemIndex}`}
                          >
                            {item?.product?.productTitle}
                          </p>
                        ))
                      )}
                    </div>
                    <span className="font-medium text-[5vw] lg:text-[1.25vw] text-textPrimaryColor whitespace-nowrap">
                      {viewOrder?.paymentDetails?.currency}{" "}
                      {viewOrder?.paymentDetails?.finalAmount}
                    </span>
                  </div>
                </div>
              </div>

              <div className="w-full h-fit flex flex-col lg:flex-row lg:justify-between items-start border-b border-accentColor p-[2%] lg:space-x-[10%]">
                <div className="w-full lg:w-[50%] h-fit flex flex-col justify-start items-start mb-[5%] lg:mb-0">
                  <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
                    MEMBER DETAILS
                  </span>
                  {viewOrder?.orderData?.map((item, index) => (
                    <div
                      className="w-full h-fit flex justify-start items-center"
                      key={index}
                    >
                      <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap mr-2">
                        {item?.patient?.name}
                      </span>
                      <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor mr-1">
                        {calculateAge(item?.patient?.dob)}
                      </span>
                      <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                        {capitalizeFirstLetter(item?.patient?.gender)}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="w-full lg:w-[50%] h-fit flex flex-col justify-start items-center">
                  <div className="w-full h-fit flex flex-col justify-start items-start mb-[7.5%]">
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
                      CONTACT NO:
                    </span>
                    <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                      {viewOrder?.userDetails?.contact}
                      
                    </span>
                  </div>
                  {/* <div className="w-full h-fit flex flex-col justify-start items-start">
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
                      FOR ANY QUERY
                    </span>
                    <span
                      className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor underline cursor-pointer mb-[2%]"
                      onClick={() => {
                        navigator.clipboard
                          .writeText("support@finelabs.in")
                          .then(() => {
                            handleNotification(
                              true,
                              "Email copied to clipboard!"
                            );
                          })
                          .catch((err) => {
                            console.error("Failed to copy text: ", err);
                            handleNotification(false, "Failed to copy email.");
                          });
                      }}
                    >
                      support@finelabs.in
                    </span>
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                      We won’t take too long to respond...
                    </span>
                  </div> */}

                  

                </div>
              </div>

              <div className="w-full h-fit grid grid-cols-2 gap-x-[15%] gap-y-[5%] border-b border-accentColor p-[2%]">
                <div className="w-full h-fit flex flex-col justify-start items-start space-y-[3%]">
                  <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                    HOME COLLECTION
                  </span>
                  <div className="w-full h-fit flex justify-start items-center">
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap mr-2">
                      {viewOrder?.collectionDate?.time},
                    </span>
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor mr-1">
                      {viewOrder?.collectionDate?.date?.dayName}
                    </span>
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor mr-1">
                      {viewOrder?.collectionDate?.date?.day}
                    </span>
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                      {viewOrder?.collectionDate?.date?.month}
                    </span>
                  </div>
                </div>
              </div>
              <div className="w-full h-fit flex flex-col lg:flex-row lg:justify-between items-start border-b border-accentColor p-[2%] lg:space-x-[10%]">
                <div className="w-full lg:w-[50%] h-fit flex flex-col justify-start items-start mb-[5%] lg:mb-0">
                  <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
                    ORDER SUMMARY
                  </span>
                  {viewOrder?.orderData?.map((orderItem, orderIndex) =>
                    orderItem?.items?.map((item, itemIndex) => (
                      <div
                        className="w-full h-fit flex justify-between items-center mb-[2%]"
                        key={`${orderIndex}-${itemIndex}`}
                      >
                        <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                          {item?.product?.productTitle}
                        </span>
                        <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap">
                          {item?.product?.currency}{" "}
                          {item?.product?.sellingPrice}
                        </span>
                      </div>
                    ))
                  )}
                  <div className="w-full h-fit flex justify-between items-center mb-[2%]">
                    <span className="font-medium text-[4vw] lg:text-[1vw] text-green-500">
                      Discount
                    </span>
                    <span className="font-medium text-[4vw] lg:text-[1vw] text-green-500 whitespace-nowrap">
                      - {viewOrder?.paymentDetails?.currency}{" "}
                      {viewOrder?.paymentDetails?.discount}
                    </span>
                  </div>
                  <div className="w-full h-fit flex justify-between items-center mb-[2%]">
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                      Collection Charges
                    </span>
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap">
                      {viewOrder?.paymentDetails?.currency}{" "}
                      {viewOrder?.paymentDetails?.collectionCharges}
                    </span>
                  </div>
                  <div className="w-full h-fit flex justify-between items-center mb-[2%]">
                    <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap">
                      Total Paid
                    </span>
                    <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                      {viewOrder?.paymentDetails?.currency}{" "}
                      {viewOrder?.paymentDetails?.finalAmount}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-[50%] h-fit flex flex-col justify-start items-center">
                  <div className="w-full h-fit flex flex-col justify-start items-start mb-[7.5%]">
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
                      ADDRESS
                    </span>
                    <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                      {viewOrder?.address?.house}, {viewOrder?.address?.area},{" "}
                      {viewOrder?.address?.city}, {viewOrder?.address?.state} -{" "}
                      {viewOrder?.address?.pincode}
                    </p>
                  </div>
                  {/* <div className="w-full h-fit flex flex-col justify-start items-start">
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
                      FOR ANY QUERY
                    </span>
                    <span
                      className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor underline cursor-pointer mb-[2%]"
                      onClick={() => {
                        navigator.clipboard
                          .writeText("support@finelabs.in")
                          .then(() => {
                            handleNotification(
                              true,
                              "Email copied to clipboard!"
                            );
                          })
                          .catch((err) => {
                            console.error("Failed to copy text: ", err);
                            handleNotification(false, "Failed to copy email.");
                          });
                      }}
                    >
                      support@finelabs.in
                    </span>
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                      We won’t take too long to respond...
                    </span>
                  </div> */}

                  {viewOrder.orderData[0].items[0].product.brandName === "Redcliffe Labs" && viewOrder.status != "Cancelled" ? (
                    <div className="w-full flex items-center justify-between gap-x-[4%]">
                      <a
                        href="https://wa.me/9138923900"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full"
                      >
                        <div className='w-full flex items-center cursor-pointer justify-center border-2 border-[#00AE1C] font-normal text-[4vw] lg:text-[1vw] text-[#00AE1C]  py-2 rounded-3xl'>
                          Support
                        </div>
                      </a>
                      {/* <div className='w-full flex items-center cursor-pointer justify-center border-[#FF3B30] border-2 font-normal text-[4vw] lg:text-[1vw] text-[#FF3B30]  py-2 rounded-3xl' onClick={() => handleCancelClick(viewOrder.bookingId)}>
                      Cancel
                    </div> */}
                    </div>
                  ) : (
                    <a
                      href="https://wa.me/9138923900"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full"
                    >
                      <div className='w-full flex items-center cursor-pointer justify-center border-2 border-[#00AE1C] font-normal text-[4vw] lg:text-[1vw] text-[#00AE1C] px-8 py-2 rounded-3xl'>
                        Support
                      </div>
                    </a>
                  )}
                  {cancelInfo && (
                    <div className="w-full h-fit mt-[2%]">
                      <p className="font-normal text-[4vw] lg:text-[1vw] text-[#FF3B30]">
                        {cancelInfo}
                      </p>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardWrapper>
  );
};

export default MyOrder;





// import React, { lazy, Suspense, useEffect, useState } from "react";
// import { useAuthContext } from "../context/AuthContext";
// import { useOrderProcessingContext } from "../context/OrderProcessingContext";
// import { MdArrowBackIos } from "../utils/Icons";
// import { formatDate, calculateAge } from "../utils/DateUtils";
// import { capitalizeFirstLetter } from "../utils/OtherUtils";
// import { useNavigate } from "react-router-dom";

// // Imports
// import DashboardWrapper from "../components/DashboardWrapper";
// const OrderCard = lazy(() => import("../components/OrderCard"));

// const MyOrder = () => {
//   const { handleNotification } = useAuthContext();
//   const { fetchOrders, allOrders, handleCancelRedcliffeOrder } = useOrderProcessingContext();
//   const [isViewOrder, setIsViewOrder] = useState(false);
//   const [viewOrder, setViewOrder] = useState({});
//   const [cancelInfo, setCancelInfo] = useState(null);
//   const navigate = useNavigate();

//   const handleViewOrder = (orderToView) => {
//     setViewOrder(orderToView);
//     setIsViewOrder((prev) => !prev);
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, [fetchOrders]);

//   const reversedOrders = [...allOrders].reverse();


//   const handleCancelClick = async(orderId) => {
//    const response = await handleCancelRedcliffeOrder(orderId);
//    setCancelInfo(response.message);
//   }

//   return (
//     <DashboardWrapper>
//       <div className="w-full h-full">
//       {!isViewOrder && (
//         <button
//         className="flex items-center font-normal text-[4vw]  mb-2 lg:hidden lg:text-[1vw] text-textPrimaryColor"
//         onClick={() => navigate(-1)}
//       >
//         <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
//         <span>Back</span>
//       </button>
//       )}
//         {allOrders?.length === 0 && !isViewOrder && (
//           <div className="w-full h-full flex justify-center items-center">
//             <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//               You haven’t ordered anything yet
//             </p>
//           </div>
//         )}

//         {reversedOrders?.length > 0 && !isViewOrder && (
//           <div className="w-full h-full flex flex-col justify-between items-center space-y-[3%] lg:space-y-0">
//             <div className="w-full h-fit lg:h-[95%] space-y-[4%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
//               <Suspense
//                 fallback={
//                   <div className="w-full h-full flex justify-center items-center">
//                     <p className="font-normal text-[1vw] text-textSecondaryColor">
//                       Loading orders...
//                     </p>
//                   </div>
//                 }
//               >
//                 {reversedOrders?.map((order, index) => (
//                   <OrderCard key={index} data={order} click={handleViewOrder} />
//                 ))}
//               </Suspense>
//             </div>
//             <button className="btn-primary">View more</button>
//           </div>
//         )}

//         {isViewOrder && viewOrder && (
//           <div className="w-full h-full space-y-[2%]">
//             <button
//               className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
//               onClick={handleViewOrder}
//             >
//               <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
//               <span>Back</span>
//             </button>
//             <div className="w-full h-fit border border-primaryColor rounded-xl lg:rounded-3xl">
//               <div className="w-full h-fit border-b border-accentColor p-[2%] lg:p-[2%]">
//                 {viewOrder?.orderData?.[0]?.items?.[0]?.product?.brandName === "Redcliffe Labs" ? (
//                   <div className="w-full h-fit flex flex-col lg:flex-row justify-between items-start lg:items-center mb-[3%]">
//                   <div className="w-full flex flex-col lg:flex-row lg:w-[70%] mb-2 lg:mb-0">
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//                       ORDER ID{" "}
//                       <span className="text-primaryColor">
//                         {viewOrder?.orderId?.slice(6).toUpperCase()}
//                       </span>
//                     </span>
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor lg:ml-[3%]">
//                       Order at : {formatDate(viewOrder?.createdAt)}
//                     </span>
//                   </div>
//                   <span className={`font-bold text-[4vw] lg:text-[1vw] ${viewOrder.status === "Cancelled" ? "text-[#FF3B30]" : "text-[#0047AF]"}`}>
//                     ORDER {viewOrder.status.toUpperCase()}
//                   </span>
//                 </div>
//                 ):(
//                    <div className="w-full h-fit flex justify-between items-center mb-[3%]">
//                   <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//                     ORDER ID{" "}
//                     <span className="text-primaryColor">
//                       {viewOrder?.orderId?.slice(6).toUpperCase()}
//                     </span>
//                   </span>
//                   <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//                     Order at : {formatDate(viewOrder?.createdAt)}
//                   </span>
//                 </div>
//                 )}
//                 <div className="w-full h-fit flex justify-between items-center space-x-[2%]">
//                   <img
//                     src={viewOrder?.orderData?.[0]?.items?.[0]?.product?.brandImg}
//                     alt="logo"
//                     className="w-[25%] lg:w-[12.5%] h-[25%] lg:h-[12.5%] object-cover rounded-xl lg:rounded-2xl"
//                   />
//                   <div className="w-[87.5%] h-fit flex justify-between items-start">
//                     <div>
//                       {viewOrder?.orderData?.map((orderItem, orderIndex) =>
//                         orderItem?.items?.map((item, itemIndex) => (
//                           <p
//                             className="w-[57.5%] font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor"
//                             key={`${orderIndex}-${itemIndex}`}
//                           >
//                             {item?.product?.productTitle}
//                           </p>
//                         ))
//                       )}
//                     </div>
//                     <span className="font-medium text-[5vw] lg:text-[1.25vw] text-textPrimaryColor whitespace-nowrap">
//                       {viewOrder?.paymentDetails?.currency}{" "}
//                       {viewOrder?.paymentDetails?.finalAmount}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//               <div className="w-full h-fit grid grid-cols-2 gap-x-[15%] gap-y-[5%] border-b border-accentColor p-[3%] lg:p-[2%]">
//                 <div className="w-full h-fit flex flex-col justify-start items-start space-y-[3%]">
//                   <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//                     MEMBER DETAILS
//                   </span>
//                   {viewOrder?.orderData?.map((item, index) => (
//                     <div
//                       className="w-full h-fit flex justify-start items-center"
//                       key={index}
//                     >
//                       <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap mr-2">
//                         {item?.patient?.name}
//                       </span>
//                       <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor mr-1">
//                         {calculateAge(item?.patient?.dob)}
//                       </span>
//                       <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                         {capitalizeFirstLetter(item?.patient?.gender)}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="w-full h-fit grid grid-cols-2 gap-x-[15%] gap-y-[5%] border-b border-accentColor p-[2%]">
//                 <div className="w-full h-fit flex flex-col justify-start items-start space-y-[3%]">
//                   <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//                     HOME COLLECTION
//                   </span>
//                   <div className="w-full h-fit flex justify-start items-center">
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap mr-2">
//                       {viewOrder?.collectionDate?.time},
//                     </span>
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor mr-1">
//                       {viewOrder?.collectionDate?.date?.dayName}
//                     </span>
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor mr-1">
//                       {viewOrder?.collectionDate?.date?.day}
//                     </span>
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                       {viewOrder?.collectionDate?.date?.month}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//               <div className="w-full h-fit flex flex-col lg:flex-row lg:justify-between items-start border-b border-accentColor p-[2%] lg:space-x-[10%]">
//                 <div className="w-full lg:w-[50%] h-fit flex flex-col justify-start items-start mb-[5%] lg:mb-0">
//                   <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
//                     ORDER SUMMARY
//                   </span>
//                   {viewOrder?.orderData?.map((orderItem, orderIndex) =>
//                     orderItem?.items?.map((item, itemIndex) => (
//                       <div
//                         className="w-full h-fit flex justify-between items-center mb-[2%]"
//                         key={`${orderIndex}-${itemIndex}`}
//                       >
//                         <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                           {item?.product?.productTitle}
//                         </span>
//                         <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap">
//                           {item?.product?.currency}{" "}
//                           {item?.product?.sellingPrice}
//                         </span>
//                       </div>
//                     ))
//                   )}
//                   <div className="w-full h-fit flex justify-between items-center mb-[2%]">
//                     <span className="font-medium text-[4vw] lg:text-[1vw] text-green-500">
//                       Discount
//                     </span>
//                     <span className="font-medium text-[4vw] lg:text-[1vw] text-green-500 whitespace-nowrap">
//                       - {viewOrder?.paymentDetails?.currency}{" "}
//                       {viewOrder?.paymentDetails?.discount}
//                     </span>
//                   </div>
//                   <div className="w-full h-fit flex justify-between items-center mb-[2%]">
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                       Collection Charges
//                     </span>
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap">
//                       {viewOrder?.paymentDetails?.currency}{" "}
//                       {viewOrder?.paymentDetails?.collectionCharges}
//                     </span>
//                   </div>
//                   <div className="w-full h-fit flex justify-between items-center mb-[2%]">
//                     <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap">
//                       Total Paid
//                     </span>
//                     <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                       {viewOrder?.paymentDetails?.currency}{" "}
//                       {viewOrder?.paymentDetails?.finalAmount}
//                     </span>
//                   </div>
//                 </div>
//                 <div className="w-full lg:w-[50%] h-fit flex flex-col justify-start items-center">
//                   <div className="w-full h-fit flex flex-col justify-start items-start mb-[7.5%]">
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
//                       ADDRESS
//                     </span>
//                     <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                       {viewOrder?.address?.house}, {viewOrder?.address?.area},{" "}
//                       {viewOrder?.address?.city}, {viewOrder?.address?.state} -{" "}
//                       {viewOrder?.address?.pincode}
//                     </p>
//                   </div>
//                   {/* <div className="w-full h-fit flex flex-col justify-start items-start">
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
//                       FOR ANY QUERY
//                     </span>
//                     <span
//                       className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor underline cursor-pointer mb-[2%]"
//                       onClick={() => {
//                         navigator.clipboard
//                           .writeText("support@finelabs.in")
//                           .then(() => {
//                             handleNotification(
//                               true,
//                               "Email copied to clipboard!"
//                             );
//                           })
//                           .catch((err) => {
//                             console.error("Failed to copy text: ", err);
//                             handleNotification(false, "Failed to copy email.");
//                           });
//                       }}
//                     >
//                       support@finelabs.in
//                     </span>
//                     <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//                       We won’t take too long to respond...
//                     </span>
//                   </div> */}
                  
//                     {viewOrder.orderData[0].items[0].product.brandName === "Redcliffe Labs" && viewOrder.status != "Cancelled" ? (
//                       <div className="w-full flex items-center justify-between gap-x-[4%]">
//                    <a
//                       href="https://wa.me/9138923900"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="w-full"
//                     >
//                       <div className='w-full flex items-center cursor-pointer justify-center border-2 border-[#00AE1C] font-normal text-[4vw] lg:text-[1vw] text-[#00AE1C]  py-2 rounded-3xl'>
//                         Support
//                       </div>
//                     </a>
//                       <div className='w-full flex items-center cursor-pointer justify-center border-[#FF3B30] border-2 font-normal text-[4vw] lg:text-[1vw] text-[#FF3B30]  py-2 rounded-3xl' onClick={() => handleCancelClick(viewOrder.bookingId)}>
//                       Cancel
//                     </div>
//                      </div>
//                     ):(
//                      <a
//                       href="https://wa.me/9138923900"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="w-full"
//                     >
//                       <div className='w-full flex items-center cursor-pointer justify-center border-2 border-[#00AE1C] font-normal text-[4vw] lg:text-[1vw] text-[#00AE1C] px-8 py-2 rounded-3xl'>
//                         Support
//                       </div>
//                     </a>
//                     )}
//                   {cancelInfo && (
//                     <div className="w-full h-fit mt-[2%]">
//                       <p className="font-normal text-[4vw] lg:text-[1vw] text-[#FF3B30]">
//                         {cancelInfo}
//                       </p>
//                     </div>
//                   )}

//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </DashboardWrapper>
//   );
// };

// export default MyOrder;
